import { ReactElement } from "react"

import AmendHpDeviceForm from "../../../../components/devices/lct/hp/amendHpDeviceForm"
import ContinueHpDeviceAmendmentProvider from "../../../../components/devices/lct/hp/providers/continueHpDeviceAmendmentProvider"

const ContinueHpDraftDeviceAmendment = (): ReactElement => (
    <ContinueHpDeviceAmendmentProvider>
        <AmendHpDeviceForm />
    </ContinueHpDeviceAmendmentProvider>
)

export default ContinueHpDraftDeviceAmendment
